// extracted by mini-css-extract-plugin
export default {"button":"styles_button__qKpM8","disabled":"styles_disabled__5yXm7","flip":"styles_flip__X0Owt","ready":"styles_ready__c99gJ","notReady":"styles_notReady__vrF2c"};